<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
  import Chart from './chart.vue'
  export default {

    props: {
      clue: {
        type: Object,
        default: () => ({})
      },
    },
    watch: {
      clue: {
        handler (newData) {
          this.setData();
        },
        immediate: true,
        deep: true
      }
    },

    data () {
      return {
        drawTiming: null,
        cdata: {
          weekLineData: []
        }
      }
    },
    components: {
      Chart,
    },
    mounted () {
      this.drawTimingFn();
    },
    beforeDestroy () {
      clearInterval(this.drawTiming);
    },
    methods: {
      drawTimingFn () {
        this.setData();
        this.drawTiming = setInterval(() => {
          this.setData();
        }, 6000);
      },
      setData () {
        // 清空轮询数据
        this.cdata.weekLineData = [];
        let total = this.clue.tagClientCount + this.clue.tagClientOKCount + this.clue.tagClientGiveUpCount;
        let percentCount = 0;
        let percentOkCount = 0;
        let percentGiveUpCount = 0;
        if (total >0){
          percentCount = (this.clue.tagClientCount / total).toFixed(2);
          percentOkCount = (this.clue.tagClientOKCount / total).toFixed(2);
          percentGiveUpCount = (this.clue.tagClientGiveUpCount / total).toFixed(2);
        }
        this.cdata.weekLineData.push({value: percentCount, name: '邀约成功'});
        this.cdata.weekLineData.push({value: percentOkCount, name: '意向客户'});
        this.cdata.weekLineData.push({value: percentGiveUpCount, name: '失败客户'});
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/echart/TypePie/index.vue